import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const ShimmerCardContainer = styled.div<SizeProps>`
  display: flex;
  padding: 32px 16px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
  .skeleton-span-container {
    display: flex;
    flex: 1;
    gap: 8px;
    flex-direction: column;
  }
`;
